import supportersTypes from './supporters.types';
export default {
  fetchsupportersLoading: state =>
    state.type === supportersTypes.FETCH_supporterS_REQUEST,
  fetchsupportersSuccess: state =>
    state.type === supportersTypes.FETCH_supporterS_SUCCESS,
  fetchsupportersFailed: state => state.type === supportersTypes.FETCH_supporterS_FAILED
};
